export default "__VITE_ASSET__Be$oXvTd__"